import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { MdEmail, MdLockOutline } from "react-icons/md";
import { FaSignInAlt } from "react-icons/fa";
import Swal from "sweetalert2";
import adlogo from '../Images/adlogo.png'
import "./admin-login.css";

const AdminLogin = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();

    try {
      const response = await fetch(
        "https://api.propertygalleria.in/admin/login",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ email, password }),
        }
      );

      const data = await response.json();

      if (response.ok) {
        sessionStorage.setItem("isAdminLoggedIn", "true");

        Swal.fire({
          icon: "success",
          title: "Welcome Back",
          text: "Access granted to Property Galleria Admin Panel",
          confirmButtonText: "Enter Dashboard",
          customClass: {
            popup: "pg-swal-popup",
            title: "pg-swal-title",
            confirmButton: "pg-swal-confirm",
          },
        });

        navigate("/admin-dashboard");
      } else {
        Swal.fire({
          icon: "error",
          title: "Authentication Failed",
          text: data.message || "Invalid credentials",
          confirmButtonText: "Try Again",
          customClass: {
            popup: "pg-swal-popup",
            title: "pg-swal-title",
            confirmButton: "pg-swal-confirm",
          },
        });
      }
    } catch {
      Swal.fire({
        icon: "error",
        title: "Server Error",
        text: "Please try again later.",
        confirmButtonText: "Close",
        customClass: {
          popup: "pg-swal-popup",
          title: "pg-swal-title",
          confirmButton: "pg-swal-confirm",
        },
      });
    }
  };




  return (
    <div className="pg-admin-wrapper">
      <div className="pg-admin-card">
        <div className="pg-logo-wrapper">
  <img
    src={adlogo}
    alt="Property Galleria Admin Logo"
    className="pg-logo-img"
  />
<h1 className="pg-logo animate-logo">
  PROPERTY <span className="pg-logo-accent">GALLERIA</span>
</h1>

<p className="pg-tagline animate-tagline">
  Secure Administrative Access
</p>

</div>


        <form onSubmit={handleLogin}>
          <div className="pg-input">
            <MdEmail />
            <input
              type="email"
              placeholder="Admin Email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
          </div>

          <div className="pg-input">
            <MdLockOutline />
            <input
              type="password"
              placeholder="Password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
          </div>

          <button className="pg-login-btn" type="submit">
            <FaSignInAlt /> Sign In
          </button>
        </form>

        <p className="pg-footer">
          © Property Galleria LLP – Admin Portal
        </p>
      </div>
    </div>
  );
};

export default AdminLogin;
